import useApi from 'src/api/useApi';

const useSyncHelper = () => {
    const { postApiData } = useApi();

    const syncItems = async (getAllItems, deleteItem, requestKeys: string[], idKey: string) => {
        const items = await getAllItems();
        items.sort((a, b) => a.lastUpdated - b.lastUpdated);

        let i = 0;
        for (const item of items) {
            let allRequestsSuccessful = true;

            try {
                const matchingRequestKeys = requestKeys.filter((r) => item[r]);

                for (const requestKey of matchingRequestKeys) {
                    const request = item[requestKey];
                    if (request) {
                        const requests = Array.isArray(request) ? request : [request];
                        for (const req of requests) {
                            const response = await postApiData({
                                fullUrl: req.url,
                                data: req.body,
                                skipRefreshCacheEndpoints: i < items.length - 1,
                                shouldReturnError: true,
                            });

                            if (!response || response instanceof Error) {
                                console.warn('Sync request failed, will retry next cycle.', item[idKey], response);
                                allRequestsSuccessful = false;
                                break;
                            }
                        }
                    }

                    if (!allRequestsSuccessful) {
                        break;
                    }
                }

                if (allRequestsSuccessful && matchingRequestKeys.length > 0) {
                    await deleteItem(item[idKey]);
                }
            } catch (error) {
                console.warn('Failed to sync item, will retry next cycle.', item[idKey], error);
            }
            i++;
        }
    };

    return {
        syncItems,
    };
};

export default useSyncHelper;
